<ng-container *transloco="let t">
  <p-panel [showHeader]="false" styleClass="p-panel-no-header p-panel-with-controls">
    <div class="container">
      <div class="icon">
        <i class="fad fa-lock"></i>
      </div>

      <div class="title">{{ t('core.pages.access_denied.title') }}</div>

      <div class="message">{{ t('core.pages.access_denied.message') }}</div>

      <div class="more-info" [class.open]="details$ | async" [class.closed]="(details$ | async) === false">
        <p-accordion (onOpen)="moreInfo(true)" (onClose)="moreInfo(false)">
          <p-accordionTab header="{{ t('core.pages.access_denied.more_info') }}" [selected]="false" transitionOptions="0.25s 10ms ease-in">
            <div class="content">
              <span class="label">{{ t('core.pages.access_denied.route') }}:</span>
              <span class="url">/{{ (authService.accessDeniedData$ | async)?.url }}</span>

              <span class="label">{{ t('core.pages.access_denied.permission') }}:</span>
              <span class="permission">{{ (authService.accessDeniedData$ | async)?.permission }}</span>

              <span class="label">{{ t('core.pages.access_denied.prev_route') }}:</span>
              <span class="permission">{{ (authService.screens$ | async)?.currentScreen?.route }}</span>
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>

      <div class="buttons">
        <button
          pButton
          type="button"
          icon="fad fa-arrow-left"
          label="{{ t('core.pages.access_denied.go_back') }}"
          class="p-button-text mr-2"
          (click)="goBack()"
        ></button>

        <button
          pButton
          type="button"
          icon="fa-duotone fa-house"
          label="{{ t('core.pages.access_denied.home') }}"
          class="p-button-text"
          (click)="goHome()"
        ></button>
      </div>
    </div>
  </p-panel>
</ng-container>
